export default {
  clients(state) {
    if (state.clients.lenght <= 0) {
      state.clients = JSON.parse(localStorage.getItem("clients")) || [];
    }
    return JSON.parse(localStorage.getItem("clients")) || [];
  },
};
